export var handleBodyScroll = {
  lock: function lock(position) {
    setTimeout(function () {
      document.body.style.position = 'fixed';
      document.body.style.top = "-".concat(position, "px");
    }, 200);
  },
  unlock: function unlock(position) {
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, position || 0);
  }
};